module.exports = __webpack_public_path__ + "static/img/KOLTYN-THOLSTRUP.b7400d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KOLTYN-THOLSTRUP.jpg
// module id = xYu+
// module chunks = 0